import { createReduxAsyncThunk } from 'shared/utils';
import { intl } from 'i18n/Translations';

import { mapApi } from '../../api';

import { MAP_STATE } from '../../constants';

import { PlannedRoutesFilter, PlannedRoutes } from '../../types';

export const getPlannedRoutes = createReduxAsyncThunk<PlannedRoutes, PlannedRoutesFilter>(
  `${MAP_STATE}/getPlannedRoutes`,
  async (filter) => {
    const { data } = await mapApi.getPlannedRoutes(filter);

    if (!data.routes || !data.routes.length) {
      throw Error(intl.formatMessage({ id: 'buildingRoute.error.impossibleToBuildRoute' }));
    }

    return data;
  }
);
